var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.4375,
    width: 44.4138,
    height: 44.4138,
    rx: 7.4023,
    fill: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2122 31.2798V14.0078C22.2122 11.9637 20.5552 10.3066 18.511 10.3066C16.4669 10.3066 14.8099 11.9637 14.8099 14.0078C14.8099 14.6891 14.2575 15.2415 13.5761 15.2415C11.5321 15.2415 9.875 16.8986 9.875 18.9427C9.875 20.9868 11.5321 22.6438 13.5761 22.6438C11.5321 22.6438 9.875 24.3008 9.875 26.3449C9.875 28.3891 11.5321 30.0461 13.5761 30.0461C14.2575 30.0461 14.8099 30.5984 14.8099 31.2798C14.8099 33.324 16.4669 34.981 18.511 34.981C20.5552 34.981 22.2122 33.324 22.2122 31.2798Z",
    stroke: "#141B34",
    strokeWidth: 1.85057,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2109 31.2798V14.0078C22.2109 11.9637 23.8679 10.3066 25.9121 10.3066C27.9562 10.3066 29.6132 11.9637 29.6132 14.0078C29.6132 14.6891 30.1656 15.2415 30.8469 15.2415C32.8911 15.2415 34.5481 16.8986 34.5481 18.9427C34.5481 20.9868 32.8911 22.6438 30.8469 22.6438C32.8911 22.6438 34.5481 24.3008 34.5481 26.3449C34.5481 28.3891 32.8911 30.0461 30.8469 30.0461C30.1656 30.0461 29.6132 30.5984 29.6132 31.2798C29.6132 33.324 27.9562 34.981 25.9121 34.981C23.8679 34.981 22.2109 33.324 22.2109 31.2798Z",
    stroke: "#141B34",
    strokeWidth: 1.85057,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsight);
export default __webpack_public_path__ + "static/media/insight.d4466c1bcfabcc9f89836ee1d02a9be8.svg";
export { ForwardRef as ReactComponent };